export default "__VITE_ASSET__RhbGWuBw__"